<template>
  <div>
    <div v-for="[collectionLabel, articles] in activeCollections" :key="collectionLabel">
      <div v-if="showCollectionHeader" class="collection-label">{{ collectionLabel }}</div>
      <ul>
        <li v-for="article in articles" :key="article.uri">
          <span
            class="article-label"
            :class="{ 'not-localized': Boolean(!article.title) }"
            @click.stop="$emit('select-article-uri', article.uri)"
            >{{ article.title || article.fallbackTitle }}</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ArticleList',
    props: {
      collections: {
        type: Array,
      },
      showCollectionHeader: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['select-article-uri'],
    computed: {
      activeCollections() {
        return this.collections.filter(([, articles]) => articles.length > 0);
      },
    },
  };
</script>

<style scoped lang="scss">
  li {
    padding-top: 0.25em;
    padding-bottom: 0.25em;
  }
  div.collection-label {
    font-weight: bold;
  }
  .not-localized {
    color: grey;
  }
  span.article-label {
    user-select: none;
    cursor: pointer;
    &:hover {
      color: #4d4ddd;
    }
  }
</style>
